import { DomManager } from "@js/core";
import components from "@js/components";

function init() {
	DomManager.setComponents(components);
}

DomManager.define({
	mounted() {
		init();
	},
});

(function (Drupal, once, $) {
	Drupal.behaviors.globalBehavior = {
		attach: function (context, settings) {
			$(document).ajaxSuccess(function (event, data) {
				DomManager.destroy();
				init();
			});
		},
	};
})(Drupal, once, jQuery);
